import { render, staticRenderFns } from "./commodity-info-quick.vue?vue&type=template&id=42eea151&scoped=true"
import script from "./commodity-info-quick.vue?vue&type=script&lang=js"
export * from "./commodity-info-quick.vue?vue&type=script&lang=js"
import style0 from "./commodity-info-quick.vue?vue&type=style&index=0&id=42eea151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eea151",
  null
  
)

export default component.exports